import { gql, TypedDocumentNode } from "@apollo/client";

import {
  LogRecordingConsentMutation,
  LogRecordingConsentMutationVariables,
} from "./RecordingConsent.generated";

export const LOG_RECORDING_CONSENT: TypedDocumentNode<
  LogRecordingConsentMutation,
  LogRecordingConsentMutationVariables
> = gql`
  mutation LogRecordingConsent(
    $action: RecordingConsentAction!
    $source: RecordingConsentSource!
    $surface: RecordingConsentSurface!
    $noteUuid: UUID
    $createdAt: DateTime
  ) {
    logRecordingConsent(
      action: $action
      source: $source
      surface: $surface
      noteUuid: $noteUuid
      createdAt: $createdAt
    ) {
      consentEventUuid
    }
  }
`;
